import bgBG from './bundles/messages/bg-BG.json';
import bsBA from './bundles/messages/bs-BA.json';
import csCZ from './bundles/messages/cs-CZ.json';
import deAT from './bundles/messages/de-AT.json';
import deDE from './bundles/messages/de-DE.json';
import hrHR from './bundles/messages/hr-HR.json';
import huHU from './bundles/messages/hu-HU.json';
import itIT from './bundles/messages/it-IT.json';
import mkMK from './bundles/messages/mk-MK.json';
import roRO from './bundles/messages/ro-RO.json';
import skSK from './bundles/messages/sk-SK.json';
import slSI from './bundles/messages/sl-SI.json';
import srRS from './bundles/messages/sr-RS.json';

interface Global extends NodeJS.Global {
  i18next?: {
    addResourceBundle<T>(
      lng: string,
      ns: string,
      resources: T,
      deep?: boolean,
      overwrite?: boolean,
    ): void;
  };
}

export const languages: [string, any][] = [
  // only "de" not "de-DE" so german is fallback
  ['de', deDE],
  ['bg-BG', bgBG],
  ['bs-BA', bsBA],
  ['cs-CZ', csCZ],
  ['de-AT', deAT],
  ['de-DE', deDE],
  ['hr-HR', hrHR],
  ['hu-HU', huHU],
  ['it-IT', itIT],
  ['mk-MK', mkMK],
  ['ro-RO', roRO],
  ['sk-SK', skSK],
  ['sl-SI', slSI],
  ['sr-RS', srRS],
];

// eslint-disable-next-line import/prefer-default-export
export const initI18next = (): void => {
  if (!(global as Global).i18next) {
    // eslint-disable-next-line no-console
    console.error('No global i18next found');
    return;
  }

  languages.forEach(([lng, res]) => {
    (global as Global).i18next?.addResourceBundle(lng, 'dm', res, true, false);
  });
};
